<template>
    <div class="brush-selector">
        <a class="btn-tool-setting"
           id="btn-freehand"
           href="#"
           :title="i18n.t('tooltip_freehand')"
           @click.prevent="setBrushMode(config.reader.tool.brushModes.freehand)"
           :class="classIsActive(config.reader.tool.brushModes.freehand)"
        >
        </a>
        <a class="btn-tool-setting"
           id="btn-straight-line"
           href="#"
           :title="i18n.t('tooltip_straightline')"
           @click.prevent="setBrushMode(config.reader.tool.brushModes.solidLine)"
           :class="classIsActive(config.reader.tool.brushModes.solidLine)"
        >
        </a>
        <a class="btn-tool-setting"
           id="btn-dotted-line"
           href="#"
           :title="i18n.t('tooltip_dottedline')"
           @click.prevent="setBrushMode(config.reader.tool.brushModes.dashLine)"
           :class="classIsActive(config.reader.tool.brushModes.dashLine)"
        >
        </a>
        <a class="btn-tool-setting"
           id="btn-arrow"
           href="#"
           :title="i18n.t('tooltip_arrow')"
           @click.prevent="setBrushMode(config.reader.tool.brushModes.arrow)"
           :class="classIsActive(config.reader.tool.brushModes.arrow)"
        >
        </a>
    </div>
</template>

<script>

    import {ref, reactive, onMounted, watchEffect, computed, watch, i18n, inject}  from "vue"
    import {useTool} from "@/modules/reader/tools/tools";
    import config from "@/config/config.json";

    export default {
        setup(props, context) {

            const {toolState, setBrushMode} = useTool();
            const i18n = inject('i18n');

            const classIsActive = (mode) =>{
                return (mode === toolState.brushSetting.lineMode) ? "active" : "";
            }

            return {
                i18n,
                toolState,
                setBrushMode,
                classIsActive,
                config
            }
        }
    }

</script>

<style scoped lang="scss">

    .brush-selector {
        padding:$tool-option-padding 0;
        flex-wrap: wrap;
        display: flex;
    }

    .brush-selector a {
        width:38px;
        height:38px;
        display:block;
        margin:$tool-icon-margin;
        background-size:38px 38px !important;
    }

    #btn-freehand {
        background:url("~images/icon_freehand.svg");
    }

    #btn-straight-line {
        background:url("~images/icon_straight_line.svg");
    }

    #btn-dotted-line {
        background:url("~images/icon_dash.svg");
    }

    #btn-arrow {
        background:url("~images/icon_arrow.svg");
    }



</style>